import { Icon } from "../Icon.js";
import admin_meds_default from "../static/admin-meds.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconAdminMeds.tsx
/* istanbul ignore file -- @preserve */
const IconAdminMeds = ({ color, height, style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: admin_meds_default,
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconAdminMeds };